import React, { useState, useEffect } from 'react'
import { i18n } from '@tops/services'
import { theme } from '@tops/global_config'
import { List, IconButton, ListItem, PageTitleDashboard, Button, Loader, MessageBanner, Pagination } from '@tops/components'

import { useRouteMatch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAccountLevels } from '../../../../actions/accountLevels'

const ViewAccountLevels = ({ history, savedInfo }) => {
  const { url } = useRouteMatch()
  const [error, setError] = useState(false)
  const [active, setActive] = useState(true)

  const [currentPage, setCurrentPage] = useState(1)

  const dispatch = useDispatch()

  const accountLevels = useSelector(state => state.accountLevels)

  useEffect(() => {
    const fetchData = async () => {

      try {
        dispatch(fetchAccountLevels(currentPage, savedInfo.id, active))
      } catch (error) {
        setError(true)
      }
    }

    fetchData()

  }, [active, currentPage])

  const handleActive = () => {
    setActive(!active)
  }


  return (
    <>
      <PageTitleDashboard title={savedInfo.name.toUpperCase()} subtitle={[i18n('SIDEBAR_LINKS').ACCOUNT_LEVELS.LABEL]}>
        <IconButton size={35} background={theme.colors.primary} icon={'Add'} text={i18n('SIDEBAR_LINKS').CREATE_LEVEL.LABEL} bold="true" textSize={14} onClick={() => history.push(`${url}/${i18n('SIDEBAR_LINKS').CREATE_LEVEL.LINK}`)} />
        <MessageBanner visible={error} status="error" message={accountLevels.error} onAccept={() => {setError(false); history.push('/cuentas')}} />
      </PageTitleDashboard>
      <span>
        <Button square small background={theme.colors.accent} selected={active} onClick={handleActive}>{i18n('ACTIVES')}</Button>
        <Button square small background={theme.colors.accent} selected={!active} onClick={handleActive}>{i18n('INACTIVES')}</Button>
      </span>
      <List>
        {
          accountLevels.isFetching ?
            <Loader /> :
            accountLevels.values.length === 0 ?
              <div style={{ fontSize: 15, marginTop: 20 }}>{i18n('NO_DATA_AVAILABLE')}</div> :
              accountLevels.values.map((item) => <ListItem
                key={item.id}
                disabled={!active}
                item={item}
                action={() => history.push(`${url}/${i18n('SIDEBAR_LINKS').EDIT_LEVEL.LINK}/${item.id}`, { isActive: active })}
              />)
        }
      </List>
      <Pagination currentPage={currentPage} itemsLength={accountLevels.values.length}
        onNext={() => setCurrentPage(currentPage + 1)} onPrev={() => setCurrentPage(currentPage - 1)} />
    </>
  )
}

export default ViewAccountLevels
